import { Slide1UKTitle } from './Slide1UKTitle'
import { Slide2UKChallenge } from './Slide2UKChallenge'
import { Slide3UKConcept } from './Slide3UKConcept'
import { Slide4UKEngagement } from './Slide4UKEngagement'
import { Slide5UKFunnel } from './Slide5UKFunnel'
import { Slide6UKQualifiedTraffic } from './Slide6UKQualifiedTraffic'
import { Slide6UKSummary } from './Slide6UKSummary'

export const slides = [
  Slide1UKTitle,
  Slide2UKChallenge,
  Slide3UKConcept,
  Slide4UKEngagement,
  Slide5UKFunnel,
  Slide6UKQualifiedTraffic,
  Slide6UKSummary,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'UK Localization Strategy' },
  { section: '1', title: 'The Challenge' },
  { section: '2', title: 'The Concept' },
  { section: '3', title: 'Top-of-Funnel Engagement' },
  { section: '4', title: 'Above-Brand Portfolio Hub' },
  { section: '5', title: 'Qualified Traffic' },
  { section: '6', title: 'Summary' },
]
